import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { TCMMasterGroupSheet, TCMMasterGroupSheetService } from "@nt-portal/tcm-sdk";
import { ResultData, ValidateResult } from "@nt-portal/common-sdk";


export interface TCMMasterGroupSheetOptions extends ControllerOptions<TCMMasterGroupSheet> {
    fieldType?: string;
}

export class ClientTCMMasterGroupSheetService extends BaseClientService implements DataController<TCMMasterGroupSheet>  {


    private _service: TCMMasterGroupSheetService;


    constructor() {
        super();
        this._service = new TCMMasterGroupSheetService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }
    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMMasterGroupSheetOptions): Promise<ResultData<TCMMasterGroupSheet>> {
        if (this.params.groupId)
            return await this._service.get(this.buildFetchParams(options), this.token, options.filter, options.fieldType);
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }



    public async export(options: TCMMasterGroupSheetOptions): Promise<ArrayBuffer | null> {

        if (this.params.groupId)
            return await this._service.export(this.token, this.buildLookupFetchParams(options), options.filter);
        return null;

    }

    public async getLookup(options: TCMMasterGroupSheetOptions): Promise<ResultData<TCMMasterGroupSheet>> {
        if (this.params.groupId) {
            let fetchParams = this.buildLookupFetchParams(options);
            let data = await this._service.get(fetchParams, this.token, options.filter, options.fieldType);
            return data;
        }
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }

    public async getById(options: TCMMasterGroupSheetOptions): Promise<TCMMasterGroupSheet | null> {
        if (options.id && this.params.groupId) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMMasterGroupSheetOptions): Promise<any> {
        if (options.id && this.params.groupId)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMMasterGroupSheetOptions): Promise<TCMMasterGroupSheet | TCMMasterGroupSheet[] | null> {
        if (options.item && options.item.id && this.params.groupId)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMMasterGroupSheetOptions): Promise<TCMMasterGroupSheet | TCMMasterGroupSheet[] | null> {
        if (options.item && this.params.groupId)
            return await this._service.add(options.item, this.token)
        return null;
    }
    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }


}